/**
 * A La Mode is a small accessibility compliant modal leveraging the HTML dialog element
 * This class represents a modal instance
 *
 * Specified and tested by Magnetic
 * Assisted-by: ChatGPT
 */

export default class AlmModal {
    constructor(dialog, id) {
        this.dialog = dialog;
        this.id = id;
        this.content = dialog.querySelector('[data-modal-content]');
        this.previouslyFocused = null;

        this.isOpening = false;
        this.isSuspended = false;

        this.init();
    }

    init() {

        let isPointerDownInside = false;


        this.dialog.addEventListener('mousedown', (e) => {
            isPointerDownInside = e.target !== this.dialog;
        });

        this.dialog.addEventListener('cancel', (e) => {
            e.preventDefault();
            aLaModeManager.close(this.id);
        });

        this.dialog.addEventListener('close', () => {
            this.onClose();
        });

        this.dialog.addEventListener('click', (e) => {

            // bouton close
            if (e.target.closest('[data-modal-close]')) {
                e.preventDefault();
                aLaModeManager.close(this.id);
                return;
            }

            // backdrop
            // backdrop click réel (pas un drag)
            if (e.target === this.dialog && !isPointerDownInside) {
                aLaModeManager.close(this.id);
            }
        });
    }

    open(payload = {}) {
        this.isOpening = true;

        this.previouslyFocused = document.activeElement;

        this.lockBackground();

        this.dialog.showModal();

        this.focusFirst();

        this.isOpening = false;
    }

    close() {
        if (!this.dialog.open) return;

        this.dialog.close();
    }

    onClose() {
        this.unlockBackground();

        if (this.previouslyFocused) {
            this.previouslyFocused.focus();
        }
    }

    setContent(html) {
        this.content.innerHTML = html;
    }

    focusFirst() {
        const el = this.dialog.querySelector(
            'a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])'
        );

        if (el) el.focus();
    }

    suspend() {
        this.isSuspended = true;
        this.dialog.inert = true;
    }

    resume() {
        this.isSuspended = false;
        this.dialog.inert = false;
    }

    lockBackground() {
        document.querySelectorAll('body > *:not(dialog)').forEach(el => {
            el.inert = true;
        });

        document.body.classList.add('modal-open');
    }

    unlockBackground() {
        document.querySelectorAll('[inert]').forEach(el => {
            el.inert = false;
        });

        document.body.classList.remove('modal-open');
    }
}
